import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Toaster } from 'react-hot-toast'
import { AuthProvider } from './contexts/AuthContext'
import Layout from './components/Layout'
import HomePage from './pages/HomePage'
import LoginPage from './pages/LoginPage'
import RegisterPage from './pages/RegisterPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import ChurchesPage from './pages/ChurchesPage'
import CompetitionsPage from './pages/CompetitionsPage'
import ResultsPage from './pages/ResultsPage'
import AdminDashboard from './pages/admin/Dashboard'
import CoordinatorDashboard from './pages/coordinator/Dashboard'
import PublicHome from './pages/public/PublicHome'
import ChurchRegistrationPublic from './pages/public/ChurchRegistrationPublic'
import TournamentRegistration from './pages/public/TournamentRegistration'
import CompetitionRegistration from './pages/participant/CompetitionRegistration'
import ProfileManagement from './pages/participant/ProfileManagement'
import ProtectedRoute from './components/ProtectedRoute'
import { useEffect } from 'react'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Route change logger component
function RouteLogger() {
  const location = useLocation()

  useEffect(() => {
    console.log('🧭 [ROUTER] Route changed', {
      timestamp: new Date().toISOString(),
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      state: location.state
    })
  }, [location])

  return null
}

function App() {
  console.log('🚀 [APP] Application initializing...', {
    timestamp: new Date().toISOString(),
    userAgent: navigator.userAgent,
    url: window.location.href,
    environment: import.meta.env.MODE,
    apiUrl: import.meta.env.VITE_API_URL
  })

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <RouteLogger />
          <div className="min-h-screen bg-gray-50">
            <Routes>
              {/* Public routes without layout */}
              <Route path="/public" element={<PublicHome />} />
              <Route path="/register/church" element={<ChurchRegistrationPublic />} />
              <Route path="/tournaments/:tournamentId/register" element={<TournamentRegistration />} />

              {/* Authentication routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />

              {/* Protected routes with layout */}
              <Route path="/" element={<Layout />}>
                <Route index element={<HomePage />} />
                <Route path="/churches" element={<ChurchesPage />} />
                <Route path="/competitions" element={<CompetitionsPage />} />
                <Route path="/results" element={<ResultsPage />} />
                <Route path="/participant/competitions" element={<CompetitionRegistration />} />
                <Route path="/participant/profile" element={<ProfileManagement />} />
                <Route
                  path="/admin/*"
                  element={
                    <ProtectedRoute requiredRole="super_admin">
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/coordinator/*"
                  element={
                    <ProtectedRoute requiredRole="church_coordinator">
                      <CoordinatorDashboard />
                    </ProtectedRoute>
                  }
                />
              </Route>
            </Routes>
            <Toaster position="top-right" />
          </div>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  )
}

export default App